/**
 * Shared keyboard focus indicator (WCAG 2.4.7).
 * Ring sits outside the control; offset-2 on mobile, offset-1 on md+ compact layouts.
 */
export const FOCUS_RING =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background md:focus-visible:ring-offset-1';
